import { Link } from 'react-router';
import ui from '@/components/ui.module.css';
import { HeroLead, PageHero } from '@/components/ui';

export function NotFound() {
  return (
    <>
      <PageHero
        eyebrow="404"
        title="That page does not exist."
        lead={
          <HeroLead>
            The link may be out of date, or the address mistyped. The main sections of the site are
            below.
          </HeroLead>
        }
      >
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 32 }}>
          <Link to="/" className={ui.buttonPrimary}>
            Back to home
          </Link>
          <Link to="/contact" className={ui.buttonSecondary}>
            Contact us
          </Link>
        </div>
      </PageHero>
    </>
  );
}
